<template>
<el-drawer title="花艺单" :visible.sync="visible" size="100%" :append-to-body="true" :center="true" :wrapperClosable="false" :withHeader="true">
    <div class="box-project">
        <div class="box-center">
            <el-collapse v-model="activeNames">
                <template v-for="(item,index) in applyList">
                    <el-collapse-item :title="item.create_time" :name="index+''" :key="'project'+item.id">
                        <template slot="title">
                            <div class="hs-collapse-item-header">
                                <div class="title"><i class="el-icon-d-caret"></i>{{item.create_time}}</div>
                                <div class="remind">
                                    <div class="remind-item">
                                        <el-button type="primary" plain @click.stop="showDrawerPass(_self, 'confirmView', 'showDrawer', [item.id,'other','flower_project'])" size="mini">{{getItemCheckTitle(item.item_check_status3)}}</el-button>
                                        <el-button type="primary" v-if="item.item_check_status3=='3'" @click.stop="showDrawerPass(_self, 'editView', 'showDrawer', [item,'edit'])">驳回修改</el-button>
                                        <el-button type="primary" v-if="item.item_check_status3==-1" @click.stop="showDrawerPass(_self, 'editView', 'showDrawer', [item,'add'])">派发</el-button>

                                    </div>
                                </div>
                            </div>
                        </template>
                        <div class="list-box">
                            <div class="list-main">
                                <el-divider content-position="left">
                                    <el-button type="primary">工程单</el-button>
                                </el-divider>
                                <div class="hs-list">
                                    <div class="hs-name">备注:</div>
                                    <div class="hs-info">{{item.remark}}</div>
                                </div>
                                <div class="hs-list">
                                    <div class="hs-name">图片:</div>
                                    <div class="hs-info">
                                        <el-image class="img" v-for="(e, i) in item.images" :key="'image'+i" :src="e.url" :preview-src-list="e.srcList"></el-image>
                                    </div>
                                </div>
                                <div class="hs-list">
                                    <div class="hs-name">文档</div>
                                    <div class="hs-info">
                                        <div v-for="(k, m) in item.files" :key="'file'+m">
                                            <a class="apply-list" :href="k.url" download="k.name">{{k.name}}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="list-aside" v-if="item.item_check_status3>-1">
                                <el-divider content-position="left">
                                    <el-button type="primary">工程单-花艺物料</el-button>
                                </el-divider>
                                <div class="main-demand">
                                    <div class="form-demand">
                                        <el-form ref="form" :model="ruleForm" label-width="80px">
                                            <div class="selected-list">
                                                <template v-for="treeitem in tree">
                                                    <div class="selected-item" :key="treeitem.id">
                                                        <div class="tree-title">{{treeitem.title}}</div>
                                                        <div class="children">
                                                            <div class="category-item" v-if="item.addons2">
                                                                <div class="category-rules">
                                                                    <div class="select-item-list">
                                                                        <div class="hs-table-pro">
                                                                            <div class="hs-table-row  hs-table-header">
                                                                                <div class="hs-table-col">花类品种</div>
                                                                                <div class="hs-table-col" v-for="(e,v) in rules" :key="v">
                                                                                    {{e.label}}
                                                                                </div>
                                                                                <div class="hs-table-col">数量</div>
                                                                                <div class="hs-table-col">使用备注</div>
                                                                            </div>
                                                                            <div class="hs-table-row" v-for="(row,index) in item.addons2" :key="index">
                                                                                <div class="hs-table-col"> {{ getTagTitle(row.category_id) }}</div>
                                                                                <div class="hs-table-col"> {{ row.spec }}</div>
                                                                                <template v-for="(e, f) in row">
                                                                                    <div class="hs-table-col" :key="f" v-if="f!='spec' &&f!='count' && f!='remark'&& f!='supplier'&& f!='price' && f!='product'&&f!='product_id' && f!='supplier_id' && f!='product_price'&& f!='category_id'&& f!='date'">
                                                                                        {{former.getRuleLabel(e,f,rules)}}
                                                                                    </div>
                                                                                </template>
                                                                                <div class="hs-table-col">{{row.count}}</div>
                                                                                <div class="hs-table-col">{{row.remark}}</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </el-form>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </el-collapse-item>
                </template>
            </el-collapse>
        </div>
        <edit-view ref="editView" :parent="_self">></edit-view>
        <confirm-view ref="confirmView"></confirm-view>
    </div>
</el-drawer>
</template>

<script>
import {
    showDrawerPass,
    getItemCheckTitle
} from '@/utils/common.js';
import former from '@/utils/former.js';
import weddingUtils from '@/utils/wedding.js';
import commentView from '@/components/comment/comment.vue';
import confirmView from '@/components/audit/confirm.vue';
import editView from './demand/edit.vue';
const ruleForm = {
    count: '',
    date: ''
};
export default {
    props: {
        dataDetail: {
            type: Object,
            default () {
                return {};
            }
        },
        projectTree: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    components: {
        commentView,
        editView,
        confirmView
    },
    data() {
        return {
            ruleForm: Object.assign({}, ruleForm),
            order_id: 0,
            module: 'wedding_project',
            module_id: 0,
            category: [],
            activeNames: ['1'],
            categoryType: [],
            parent_id: 0,

            tree: {},
            selected: [],
            forms: {},
            applyList: [],
            activeNames: ['0'],
            visible: false,
            confirm: {},
            confirmStep: [],
            rules: []
        }
    },
    beforeCreate() {
        this.showDrawerPass = showDrawerPass;
        this.former = former;
        this.getRuleTag = weddingUtils.getRuleTag;
        this.getItemCheckTitle = getItemCheckTitle;
    },
    created() {

    },
    methods: {
        showDrawer(options) {
            let _this = this;
            let url = '/api/wedding.demand/read';
            this.order_id = options;
            _this.visible = true
            this.$post(url, {
                order_id: options,
                type: "project",
                type1: "flower_project"
            }).then(res => {
                let resData = res.data;
                _this.applyList = resData.demands;
                _this.tree = res.data.tree;
                _this.tree.map(item => {
                    item.children.map(i => {
                        _this.rules = i.rules;
                    })
                })

            })
        },
        //对应id到name
        getTagTitle(id) {
            let tree = this.tree;
            let title = '';
            tree.forEach((item) => {
                item.children.map(i => {
                    if (i.id == id) {
                        title = i.title;
                    }
                })

            });

            return title;
        },
        checkStatus(id) {
            this.getAuditResult(id)
        },
        // 获取审核流程
        getAuditResult(id) {
            let _this = this;
            let url = '/api/wedding.demand/getAuditResult';
            let params = {
                id: id,
            };
            _this.$post(url, params).then(res => {
                if (res.code == 200) {
                    let auditProcess = res.data.process;
                    _this.confirmStep = auditProcess;

                } else {
                    _this.$message.warning(res.msg);
                }
            });
        },
    }
}
</script>

<style lang="less" scoped>
@import url('@/assets/css/common.less');

.box-project {
    display: flex;

    .box-center {
        flex: 1;
        padding: 12px;

        .list-box {
            display: flex;

            .list-main {
                flex: 0 25%;

                padding: 12px;
            }

            .list-aside {
                flex: 1;
                padding: 12px;
                border-left: 1px solid #dedede;
            }

        }
    }

    .box-comment {
        flex: 0 25%;
        border-left: 1px solid #dedede;
        padding: 12px;
    }

    .img {
        width: 100px;
        height: 100px;
        margin-right: 10px;
    }

    .apply-list {
        padding: 5px 0;
        display: block;
    }
}

.selected-list {
    padding-left: 12px;
}

.selected-item {
    position: relative;
    cursor: pointer;

    .tree-title {
        padding: 8px;
        font-size: 14px;
        font-weight: 600;
    }

    .category-item {
        display: flex;
        border-top: 1px solid #dedede;

        .category-title {
            display: flex;
            width: 5rem;
            padding: 8px;
            align-items: center;
        }

        .category-rules {
            flex: 1;
            border-left: 1px solid #dedede;

            .category-item-form {
                padding: 8px;
                display: flex;

                .attr-date,
                .attr-select,
                .attr-textarea {
                    margin-right: 5px;
                    max-width: 120px;
                }

                .attr-input {
                    margin-right: 5px;
                    max-width: 120px;
                    min-width: 80px;
                }

                .attr-count {
                    margin-right: 5px;
                    width: 7rem;
                }

                .attr-remark {
                    margin-right: 5px;
                    flex: 1;
                }
            }
        }
    }

    .category-item:last-child {
        border-bottom: 1px solid #dedede;
    }

}

.selected-item:last-child {
    border-bottom: none;
}

/*** --------------------------------------- 分界线 ------------------------ ***/
.form-header {
    position: fixed;
    left: 0;
    top: 0;
    display: flex;
    width: 75%;
    padding: 12px;
    border-bottom: 1px solid #dedede;
    border-right: 1px solid #dedede;

    .form-submit {
        flex: 1;
        text-align: right;
    }
}

.main-demand {
    display: flex;
    overflow: hidden;

    .form-demand {
        flex: 1;
        overflow: auto;
        padding: 12px 12px 30px 12px;
    }

    .more-demand {
        flex: 0 25%;
        padding: 12px;
        padding: 12px 12px 30px 12px;
    }
}

.hs-table-pro {
    .hs-table-row {
        display: flex;
        border-top: .5px solid #f6f7fb;

        .hs-table-col {
            flex: 1;
            padding: 5px 8px;
            border-right: .5px solid #f6f7fb;
        }

        .hs-table-col.w80 {
            flex: 0 80px;
        }
    }

    .hs-table-row.hs-table-header {
        background: #f6f7fb;
        border-top: none;
    }
}
</style>
